export const parseCPUValue = (value: string): number => {
    if (!value) return 0;
    
    let result = 0;
    if (value.endsWith('n')) {
        // Convert nanoseconds to millicores (divide by 1000000)
        result = parseFloat(value.slice(0, -1)) / 1000000;
    } else if (value.endsWith('m')) {
        // Already in millicores
        result = parseFloat(value.slice(0, -1));
    } else {
        // Handle plain numbers that represent CPU cores
        result = parseFloat(value) * 1000; // Convert cores to millicores
    }
    return result;
};

export const parseMemoryValue = (value: string): number => {
    if (!value) return 0;

    let result = 0;
    if (value.endsWith('Ki')) {
        result = parseFloat(value.slice(0, -2)) / 1024; // Convert KiB to MiB
    } else if (value.endsWith('Mi')) {
        result = parseFloat(value.slice(0, -2));
    } else if (value.endsWith('Gi')) {
        result = parseFloat(value.slice(0, -2)) * 1024;
    } else {
        // Handle plain numbers that represent bytes
        result = parseFloat(value) / (1024 * 1024); // Convert bytes to MiB
    }
    return result;
};

export function calculatePercentage(usage: string, capacity: string, type: 'cpu' | 'memory'): number {
    if (type === 'memory') {
        const usageValue = parseMemoryValue(usage);
        const capacityValue = parseMemoryValue(capacity);
        return capacityValue === 0 ? 0 : (usageValue / capacityValue) * 100;
    }

    // CPU percentage calculation using parseCPUValue
    const usageValue = parseCPUValue(usage);
    const capacityValue = parseCPUValue(capacity);
    return capacityValue === 0 ? 0 : (usageValue / capacityValue) * 100;
}

export function formatCPU(value: string): string {
    if (!value) return '-';
    
    // Convert to millicores first
    const millicores = parseCPUValue(value);
    
    if (isNaN(millicores)) return '-';

    //if (millicores < 1000) {
        return `${Math.round(millicores)}m`;
    //}
    //return `${(millicores / 1000).toFixed(2)}`;
}

export function formatMemory(value: string): string {
    if (!value) return '-';

    // Convert to MiB first
    const mibValue = parseMemoryValue(value);
    
    if (isNaN(mibValue)) return '-';

    //if (mibValue < 1024) {
        return `${Math.round(mibValue)}Mi`;
    //}
    //return `${(mibValue / 1024).toFixed(1)}Gi`;
}

export function getCPUColor(percentage: number): string {
    if (percentage >= 80) return 'var(--bulk-error)'; // error
    if (percentage >= 60) return 'var(--bulk-warning)'; // warning
    return 'inherit';
}

export function getMemoryColor(percentage: number): string {
    if (percentage >= 80) return 'var(--bulk-error)'; // error
    if (percentage >= 60) return 'var(--bulk-warning)'; // warning
    return 'inherit';
} 